import { render, staticRenderFns } from "./BuyerNewJobTextInfo.vue?vue&type=template&id=e47da066&scoped=true&"
var script = {}
import style0 from "@assets/css/buyer-job-text.css?vue&type=style&index=0&id=e47da066&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47da066",
  null
  
)

export default component.exports